import developmentConfig from "../../config/app.development.config.json";
import { ENV_DEV, ENV_TEST } from "../Constants/CommonConstants";

const config = window.APP_CONFIG;
const ConfigService = (key) => {
  const data =
    process.env.NODE_ENV === ENV_DEV || process.env.NODE_ENV === ENV_TEST
      ? developmentConfig[key]
      : config[key];
  return data || null;
};

export default ConfigService;
